export default {
	'app-logo': require('../../images/icon/wind-ui/icon-app-logo.png'),
	'todo-order': require('../../images/icon/wind-ui/icon-todo-order.png'),
	'toSend-order': require('../../images/icon/wind-ui/icon-tosend-order.png'),
	'filter-extend': require('../../images/icon/wind-ui/icon-filter-extend.png'),
	'filter-unextend': require('../../images/icon/wind-ui/icon-filter-unextend.png'),
	'arrow-right': require('../../images/icon/wind-ui/icon-arrow-right.png'),
	'arrow-left': require('../../images/icon/wind-ui/icon-arrow-left.png'),
	'arrow-up': require('../../images/icon/wind-ui/icon-arrow-up.png'),
	'arrow-down': require('../../images/icon/wind-ui/icon-arrow-down.png'),
	'add-round': require('../../images/icon/wind-ui/icon-add-round.png'),
	'img-watch': require('../../images/icon/wind-ui/icon-search.png'),
	'img-change': require('../../images/icon/wind-ui/icon-img-change.png'),
	'img-del': require('../../images/icon/wind-ui/icon-img-del.png'),
	'image-watch': require('../../images/icon/wind-ui/icon-image-watch.png'),
	'file-watch': require('../../images/icon/wind-ui/icon-file-watch.png'),
	'file-del': require('../../images/icon/wind-ui/icon-file-del.png'),
	'file-type-default': require('../../images/icon/wind-ui/icon-file-type-default.png'),
	'file-type-excel': require('../../images/icon/wind-ui/icon-file-type-excel.png'),
	'file-type-word': require('../../images/icon/wind-ui/icon-file-type-word.png'),
	'file-type-ppt': require('../../images/icon/wind-ui/icon-file-type-ppt.png'),
	'header-more': require('../../images/icon/wind-ui/icon-header-more.png'),
	'delete-trash': require('../../images/icon/wind-ui/icon-delete-trash.png'),
	'exclamation-mark': require('../../images/icon/wind-ui/icon-mark.png'),
	'exclamation-mark-active': require('../../images/icon/wind-ui/icon-mark-active.png'),
	'question-active': require('../../images/icon/wind-ui/icon-question-active.png'),
	'copy-single': require('../../images/icon/wind-ui/icon-copy-single.png'),
	'copy-mulity': require('../../images/icon/wind-ui/icon-copy-mulity.png'),
	'lower-items': require('../../images/icon/wind-ui/lower-items.png'),
	'icon-import': require('../../images/icon/wind-ui/icon-import.png'),
	'copy-order': require('../../images/icon/wind-ui/icon-copy-order.png'),
	'connect-employee': require('../../images/icon/wind-ui/icon-connect-employee.png'),
	'connect-item': require('../../images/icon/wind-ui/icon-connect-item.png'),
	'auth-setting': require('../../images/icon/wind-ui/icon-auth-setting.png'),
	'export-excel': require('../../images/icon/wind-ui/icon-export-excel.png'),
	'export-excel-blue': require('../../images/icon/wind-ui/icon-export-excel-blue.png'),
	'export-data': require('../../images/icon/wind-ui/icon-export-data.png'),
	'export-data-blue': require('../../images/icon/wind-ui/icon-export-data-blue.png'),
	'fast-outStore': require('../../images/icon/wind-ui/icon-fast-outStore.png'),
	'child-fast-outStore': require('../../images/icon/wind-ui/icon-child-fast-outStore.png'),
	'child-fast-move': require('../../images/icon/wind-ui/icon-child-fast-move.png'),
	'get-price': require('../../images/icon/wind-ui/icon-get-price.png'),
	'push-middle-ground': require('../../images/icon/wind-ui/icon-push-middle-ground.png'),
	replace: require('../../images/icon/wind-ui/icon-replace.png'),
	'export-template': require('../../images/icon/wind-ui/icon-export-template.png'),
	'import-template': require('../../images/icon/wind-ui/icon-import-template.png'),
	'import-custom': require('../../images/icon/wind-ui/icon-import-custom.png'),
	'import-excel': require('../../images/icon/wind-ui/icon-import-excel.png'),
	'query-stock': require('../../images/icon/wind-ui/icon-query-stock.png'),
	'fasong-trash': require('../../images/icon/wind-ui/icon-fasong-trash.png'),
	refresh: require('../../images/icon/wind-ui/icon-refresh.png'),
	star: require('../../images/icon/wind-ui/icon-star.png'),
	'import-must': require('../../images/icon/wind-ui/icon-import-grey.png'),
	'refresh-grey': require('../../images/icon/wind-ui/icon-refresh-grey.png'),
	'refresh-blue': require('../../images/icon/wind-ui/icon-refresh-blue.png'),
	'bom-edit': require('../../images/icon/wind-ui/icon-bom-edit.png'),
	'bom-save': require('../../images/icon/wind-ui/icon-bom-save.png'),
	'bom-del': require('../../images/icon/wind-ui/icon-bom-del.png'),
	'bom-add': require('../../images/icon/wind-ui/icon-bom-add.png'),
	'spec-add': require('../../images/icon/wind-ui/icon-spec-add.svg'),
	'spec-del': require('../../images/icon/wind-ui/icon-spec-del.svg'),
	'bom-change': require('../../images/icon/wind-ui/icon-bom-change.png'),
	'instore-assign': require('../../images/icon/wind-ui/icon-instore-assign.png'),
	'outstore-assign': require('../../images/icon/wind-ui/icon-outstore-assign.png'),
	'stockplan-assign': require('../../images/icon/wind-ui/icon-stockplan-assign.png'),
	'push-assign': require('../../images/icon/wind-ui/icon-push-assign.png'),
	print: require('../../images/icon/wind-ui/icon-print-grey.png'),
	'print-blue': require('../../images/icon/wind-ui/icon-print-blue.png'),
	logout: require('../../images/icon/wind-ui/logout.png'),
	'bill-chain': require('../../images/icon/wind-ui/icon-bill-chain.png'),
	waiting: require('../../images/icon/wind-ui/icon-waiting.png'),
	'carry-forward-store': require('../../images/icon/wind-ui/icon-carry-forward-store.png'),
	'carry-forward-success': require('../../images/icon/wind-ui/icon-carry-forward-success.png'),
	'carry-forward-fail': require('../../images/icon/wind-ui/icon-carry-forward-fail.png'),
	'carry-forward-process': require('../../images/icon/wind-ui/icon-carry-forward-process.png'),
	'carry-forward-process-success': require('../../images/icon/wind-ui/icon-carry-forward-process-success.png'),
	'goods-push': require('../../images/icon/wind-ui/icon-goods-push.png'),
	'goods-unbind': require('../../images/icon/wind-ui/icon-goods-unbind.png'),
	'mistake-check-step-active': require('../../images/icon/wind-ui/icon-mistake-check-step-active.png'),
	'mistake-check-step-pass': require('../../images/icon/wind-ui/icon-mistake-check-step-pass.png'),
	'mistake-check-step-unknow': require('../../images/icon/wind-ui/icon-mistake-check-step-unknow.png'),


	// {{{ 树形组件可用icon
	'tree-extend': require('../../images/icon/tree/common/icon-tree-extend.png'),
	'tree-unextend': require('../../images/icon/tree/common/icon-tree-unextend.png'),
	'tree-width-extend': require('../../images/icon/tree/common/icon-tree-width-extend.png'),
	'tree-width-unextend': require('../../images/icon/tree/common/icon-tree-width-unextend.png'),
	'tree-node-tools': require('../../images/icon/tree/common/icon-tree-node-tools.png'),
	'tree-node-edit': require('../../images/icon/tree/common/icon-tree-edit.png'),
	'tree-node-add': require('../../images/icon/tree/common/icon-tree-add.png'),
	'tree-node-delete': require('../../images/icon/tree/common/icon-tree-delete.png'),
	'tree-search-arrow-left': require('../../images/icon/tree/common/icon-tree-search-arrow-left.png'),
	'tree-search-arrow-right': require('../../images/icon/tree/common/icon-tree-search-arrow-right.png'),
	// }}}
	// {{{ 机构类型icon
	'organ-type-group': require('../../images/icon/wind-ui/icon-organ-type-group.png'),
	'organ-type-region': require('../../images/icon/wind-ui/icon-organ-type-region.png'),
	'organ-store': require('../../images/icon/wind-ui/icon-organ-type-store.png'),
	'organ-shop': require('../../images/icon/wind-ui/icon-organ-type-shop.png'),
	'organ-rdc': require('../../images/icon/wind-ui/icon-organ-type-rdc.png'),
	'organ-section': require('../../images/icon/wind-ui/icon-organ-type-section.png'),
	'organ-supplier': require('../../images/icon/wind-ui/icon-organ-type-supplier.png'),
	'organ-supplier-type': require('../../images/icon/wind-ui/icon-organ-type-supplier-type.png'),
	'organ-customer': require('../../images/icon/wind-ui/icon-organ-type-customer.png'),
	'organ-customer-type': require('../../images/icon/wind-ui/icon-organ-type-supplier-type.png'),
	'organ-customer-company': require('../../images/icon/wind-ui/icon-organ-type-supplier-company.png'),
	'storage-rack': require('../../images/icon/wind-ui/icon-storage-rack.png'),
	// }}}
	// {{{ table
	'tabel-column-filter': require('../../images/icon/table/icon-table-column-filter.png'),
	'tabel-header-arrow-left': require('../../images/icon/table/icon-table-header-arrow-left.png'),
	'tabel-header-arrow-right': require('../../images/icon/table/icon-table-header-arrow-right.png'),
	'tabel-remove': require('../../images/icon/table/icon-table-remove.png'),
	'tabel-sum': require('../../images/icon/table/icon-table-sum.svg'),
	// }}}
	// {{{ table-details
	'table-details-delete': require('../../images/icon/table/icon-table-delete.png'),
	'table-details-safe': require('../../images/icon/table/icon-table-safe.png'),
	'table-details-full-screen': require('../../images/icon/table/icon-table-full-screen.png'),
	'table-details-unFull-screen': require('../../images/icon/table/icon-table-unFull-screen.png'),
	'table-details-expand': require('../../images/icon/table/icon-table-expand.png'),
	'table-details-fold': require('../../images/icon/table/icon-table-fold.png'),
	'table-details-setting': require('../../images/icon/table/icon-table-setting.png'),
	'details-list-empty': require('../../images/icon/wind-ui/icon-details-table-empty.png'),
	// }}}
	// {{{ table-details-plus
	'table-details-product': require('../../images/icon/table/icon-table-product.png'),
	'table-details-dosing': require('../../images/icon/table/icon-table-dosing.png')
	// }}}
}
